import React from "react";

import {Header as MyHeader} from "../../../components";
import {Redirect, Route, Switch} from "react-router";

import {Courses} from "./Courses";
import {Orders} from "./Orders";
import {Learn} from "./Learn";

export const People = () => {
    return (
        <React.Fragment>
            <MyHeader/>
            <Switch>
                <Route exact path={'/people/courses'}>
                    <Courses/>
                </Route>
                <Route exact path={'/people/orders'}>
                    <Orders/>
                </Route>
                <Route exact path={'/people/course/:id/:uuid'}>
                    <Learn/>
                </Route>
                <Redirect to={'/people/courses'}/>
            </Switch>
        </React.Fragment>
    )
}

